<ng-container *transloco="let t">
  <div [formGroup]="form" class="owner-statement-deregistration">
    <h3 class="mb-2">
      {{ t('Owner Statement Regarding Deregistration From Central Database') }}
    </h3>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('Deregistration reason') }}</mat-label>
      <mat-select formControlName="deregistrationReason">
        <mat-option [value]="t('Natural death')">{{
          t('Natural death')
        }}</mat-option>
        <mat-option [value]="t('Euthanasia')">{{ t('Euthanasia') }}</mat-option>
        <mat-option [value]="t('Sale')">{{ t('Sale') }}</mat-option>
        <mat-option [value]="t('Ran away')">{{ t('Ran away') }}</mat-option>
        <mat-option [value]="t('Missing / Being searched')">{{
          t('Missing / Being searched')
        }}</mat-option>
        <mat-option [value]="t('Other')">{{ t('Other') }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('Note') }}</mat-label>
      <textarea matInput formControlName="note" rows="4"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
